import React from "react";
import { FaRocket } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function TokenomicsSection() {
  return (
    <section className="w-full bg-black py-6 px-2" id="tokenomics">
      <div className="mx-auto w-full max-w-[1800px] border border-[#c4dc5b]/30 rounded-xl overflow-hidden bg-[#050505]">
        <div className="grid lg:grid-cols-2 gap-0">
          {/* LEFT SIDE */}
          <div className="border-b lg:border-b-0 lg:border-r border-[#c4dc5b]/30 p-4">
            <h2 className="text-[#c4dc5b] text-2xl font-bold mb-4">
              TOKENOMICS
            </h2>

            <div className="text-gray-300 mb-4">
              <span className="font-semibold">TOTAL SUPPLY:</span>{" "}
              42,000,000,000,000 ETHRA
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-4">
              {/* Chart */}
       <div className="relative shrink-0">
  <div
    className="relative w-56 h-56 rounded-full"
    style={{
      background:
        "conic-gradient(#c4dc5b 0% 25%, #178b2f 25% 50%, #1fa8d8 50% 70%, #7a2be2 70% 85%, #ff9b21 85% 95%, #ff4b3e 95% 100%)",
    }}
  >
    {/* middle black hole */}
    <div className="absolute inset-[50px] rounded-full bg-black flex items-center justify-center">
      {/* logo circle */}
      <div className="w-24 h-24 rounded-full bg-[#050505] border-4 border-[#c4dc5b] flex items-center justify-center overflow-hidden shadow-[0_0_18px_rgba(196,220,91,0.35)]">
        <img
          src="/22.png"
          alt="Logo"
          className="w-16 h-16 object-contain"
        />
      </div>
    </div>
  </div>
</div>

              {/* Legend */}
            <div className="space-y-2 w-full">
  <Legend
    color="#c4dc5b"
    label="25% Presale"
    value="10,500,000,000,000"
  />
  <Legend
    color="#4CAF50"
    label="25% Liquidity (Locked at Launch)"
    value="10,500,000,000,000"
  />
  <Legend
    color="#2196F3"
    label="20% Rewards / Revenue"
    value="8,400,000,000,000"
  />
  <Legend
    color="#9C27B0"
    label="15% Development (Vested)"
    value="6,300,000,000,000"
  />
  <Legend
    color="#FF9800"
    label="10% Marketing (Vested)"
    value="4,200,000,000,000"
  />
  <Legend
    color="#F44336"
    label="5% Reserve"
    value="2,100,000,000,000"
  />
</div>
            </div>

          <div className="mt-4 pt-4 border-t border-[#c4dc5b]/30 flex justify-between items-center text-lg">
  <span className="text-white font-medium">
    Total 100%
  </span>

  <span className="text-[#c4dc5b] font-bold">
    42,000,000,000,000
  </span>
</div>
          </div>

          {/* RIGHT SIDE */}
          <div className="p-4">
            <h2 className="text-[#c4dc5b] text-2xl font-bold mb-4">
              PRESALE INFORMATION
            </h2>

            <div className="space-y-2 text-gray-300">
  <InfoRow label="Soft Cap" value="$500,000" />
  <InfoRow label="Hard Cap" value="$1,000,000" />
  <InfoRow
    label="Presale Allocation"
    value="25% (10,500,000,000,000)"
  />
  <InfoRow
    label="Token Price (Stage 1)"
    value="$0.0000000200"
  />
  <InfoRow label="Network" value="Ethereum (ERC-20)" />
  <InfoRow label="Accepted" value="ETH, USDT, BNB" />
</div>

            <div className="mt-4">
              <h3 className="text-[#c4dc5b] font-semibold mb-2">
                PRESALE STAGES
              </h3>

              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-[#c4dc5b]/20 text-[#c4dc5b]">
                      <th className="py-2 text-left">Stage</th>
                      <th className="py-2 text-left">Tokens</th>
                      <th className="py-2 text-left">Price</th>
                      <th className="py-2 text-left">Target</th>
                    </tr>
                  </thead>

                 <tbody className="text-gray-300">
  <tr>
    <td className="py-2">Stage 1</td>
    <td>2.5T</td>
    <td>$0.0000000200</td>
    <td>$250,000</td>
  </tr>

  <tr>
    <td className="py-2">Stage 2</td>
    <td>3.0T</td>
    <td>$0.0000000230</td>
    <td>$250,000</td>
  </tr>

  <tr>
    <td className="py-2">Stage 3</td>
    <td>3.0T</td>
    <td>$0.0000000260</td>
    <td>$250,000</td>
  </tr>

  <tr>
    <td className="py-2">Stage 4</td>
    <td>2.0T</td>
    <td>$0.0000000265</td>
    <td>$250,000</td>
  </tr>
</tbody>
                </table>
              </div>

        <div className="mt-2 flex items-center justify-between rounded-lg border border-[#c4dc5b]/30 bg-gradient-to-r from-[#142b03] via-[#1a3506] to-[#142b03] px-4 py-2 shadow-[0_0_20px_rgba(196,220,91,0.15)]">
  <span className="text-[#c4dc5b] font-bold text-sm md:text-base">
    TOTAL
  </span>

  <span className="text-[#c4dc5b] font-bold text-sm md:text-base">
    10,500,000,000,000
  </span>

  <span className="text-[#c4dc5b] font-bold text-sm md:text-base">
    $250,000
  </span>
</div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#c4dc5b]/30">
          <div className="grid lg:grid-cols-[1fr_520px] items-center">
            {/* Left Side */}
            <div className="relative p-4">
              <h3 className="text-white text-lg font-semibold uppercase">
                USDT RAISED
              </h3>

              <div className="mt-2 text-4xl font-bold">
                <span className="text-[#c4dc5b]">$0</span>
                <span className="text-white text-2xl"> / $250,000</span>
              </div>

              <div className="mt-3 flex items-center gap-3">
                <div className="flex-1 h-[6px] rounded-full border border-[#c4dc5b]/20 bg-[#111] overflow-hidden">
                  <div className="h-full w-[0%] bg-[#c4dc5b]" />
                </div>

                <span className="text-[#c4dc5b] font-semibold text-sm">
                  0%
                </span>
              </div>

              {/* Divider */}
              <span className="absolute right-0 top-1/2 hidden h-[75%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent lg:block" />
            </div>

            {/* Right Side */}
            <div className="flex flex-col items-center justify-center px-8 py-4">
<button
  onClick={() => window.location.href = "/presale"}
  className="w-full h-[70px] rounded-xl border border-[#c8f53a] bg-[linear-gradient(180deg,#b5e003_0%,#9dcb01_100%)] text-[30px] font-extrabold text-[#111] shadow-[0_10px_30px_rgba(157,203,1,0.4)] transition hover:brightness-105 flex items-center justify-center gap-3"
>
  <span>Join Presale Now</span>

  <img
    src="/rocket.png"
    alt="Rocket"
    className="w-7 h-7 object-contain"
  />
</button>

              <div className="mt-2 flex items-center gap-2 text-base text-gray-400">
                <span>Secure Payments With</span>

                <img
                  src="/usdt.svg"
                  alt="Tether"
                  className="h-6 w-6 object-contain"
                />

                <span className="text-white">tether</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between border-b border-[#c4dc5b]/10 pb-2">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}

function Legend({ color, label, value }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <span
          className="w-4 h-4 rounded-sm"
          style={{ backgroundColor: color }}
        />
        <span className="text-white">{label}</span>
      </div>

      <span className="text-[#c4dc5b] text-sm">{value}</span>
    </div>
  );
}